import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import axios from "axios";
import "../ECommerce/ECommerce.css";
import "./Blogs.css";
import "../Page.css";
import AccordionItem from "../../Components/UI-Controls/Accordian/Accordian";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import Logo from "../../../src/Assets/Images/Logo 29.44 X 5.12.png";
import Selector from "../../../src/Assets/Images/Selector 20 X 20.png";
import MainLoader from "../../Components/UI-Controls/MainLoader/MainLoader";
import SearchMultiple from "../../Components/UI-Controls/MultiSelect/BlogTagSelect";
import JoditEditor from "jodit-react";
import "../../../src/JoditEditorStyle.css";
import { security_key, Url, imageConfigEditor } from "../../Services/Api";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import { useLocation, useNavigate } from "react-router-dom";
import { PiNotePencil } from "react-icons/pi";
import imageStatus from "../../../src/Assets/Images/StatusImg 20 x 20.png";
import imageVisibility from "../../../src/Assets/Images/Visibility 20 x 20.png";
import imagePublish from "../../../src/Assets/Images/Publish 20 x 20.png";
import { IoImageOutline } from "react-icons/io5";
import ImageGalleryPopup from "../../Components/UI-Controls/PopUp/ImageGalleryPapup/ImageGalleryPopup";
import { uploadImage } from "../../Services/functions";
import BottomToust from "../../Components/BottomToust/BottomToust";
import { BsEye } from "react-icons/bs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const AddBlogs = () => {
  /* ─── Categories & Tags ─── */
  const [blogsCategories, setBlogsCategories] = useState([]);
  const [blogsTag, setBlogsTag] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  const [publishDate, setPublishDate] = useState(null);
  const [showPublishDatePicker, setShowPublishDatePicker] = useState(false);

  /* ─── Accordion open states ─── */
  const [accordionsOpen, setAccordionsOpen] = useState({});

  /* ─── SEO preview tab ─── */
  const [selectedView, setSelectedView] = useState("Web");
  const [isMobileAnimating, setIsMobileAnimating] = useState(false);
  const [isWebAnimating, setIsWebAnimating] = useState(false);

  /* ─── Loading / toast ─── */
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(null);
  const [showMessage, setShowMessage] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [submissionActive, setSubmissionActive] = useState(false);

  /* ─── Editor tab ─── */
  const [selectedTab, setSelectedTab] = useState("Visual");

  /* ─── Mode flags ─── */
  const [isViewMode, setIsViewMode] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isEditID, setIsEditID] = useState(null);
  const [isEdit, setIsEdit] = useState([]);
  const [isView, setIsView] = useState([]);

  /* ─── Sidebar display values ─── */
  const [productStatus, setProductStatus] = useState("");
  const [productVisibility, setProductVisibility] = useState("");
  const [productPublishedStatus, setPublishedStatus] = useState("");
  const [productCreatedStatus, setCreatedStatus] = useState("");

  /* ─── Tag dropdown ─── */
  const [dropdownHeight, setDropdownHeight] = useState(0);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  /* ─── Main form ─── */
  const [formData, setFormData] = useState({
    title: "",
    slug: "",
    author: "",
    content: "",
    selectedCategory: "",
    blogsTag: [],
    status: "draft",
  });

  /* ─── SEO / Meta ─── */
  const [metaData, setMetaData] = useState({
    metaTitle: "",
    metaDescription: "",
    metaKeywords: "",
    canonicalUrl: "",
    robots: "",
    ogTitle: "",
    ogDescription: "",
    og_image: "",
    xTitle: "",
    xDescription: "",
    x_image: "",
    schemaMarkup: "",
  });

  /* ─── Blog featured image ─── */
  const [blogImage, setBlogImage] = useState(null);

  /* ─── OG / X image states ─── */
  const [selectedOgImage, setSelectedOgImage] = useState(null);
  const [selectedXImage, setSelectedXImage] = useState(null);

  /* ─── Image gallery modal ─── */
  const [modalView, setModalView] = useState(false);
  const [modaldata, setModalData] = useState([]);
  const [isUploaded, setIsUploaded] = useState(false);
  const [uploadedStatus, setUploadedStates] = useState(null);
  const [imageType, setImageType] = useState("");
  const [imageSendPayload, setImageSendPayload] = useState({
    file: null,
    alt_text: "",
    title: "",
    description: "",
    link_url: "",
  });

  const editor = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { blog_Data, view_Data } = location.state || {};

  /* ════════════════════════════════════
     Helpers
  ════════════════════════════════════ */
  const capitalizeFirstLetter = (string) =>
    string ? string.charAt(0).toUpperCase() + string.slice(1) : "";

  const formatDate = (dateString) => {
    if (!dateString) return "Not Published Yet";
    return new Date(dateString).toLocaleDateString();
  };

  const generateSlug = (name) =>
    name
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^a-z0-9-]/g, "")
      .replace(/-+/g, "-");

  /* ════════════════════════════════════
     Toast auto-hide
  ════════════════════════════════════ */
  useEffect(() => {
    if (showMessage === true) {
      const timeOut = setTimeout(() => setShowMessage(false), 3000);
      return () => clearTimeout(timeOut);
    }
  }, [showMessage]);

  /* ════════════════════════════════════
     Image gallery API
  ════════════════════════════════════ */
  const getApi = async () => {
    try {
      const response = await axios.get(`${Url}/api/v1/media/blogs/get`);
      setModalData(response.data.media);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getApi();
  }, []);

  useEffect(() => {
    if (isUploaded) {
      getApi();
      setIsUploaded(false);
    }
  }, [isUploaded]);

  /* ════════════════════════════════════
     Gallery modal open / close
  ════════════════════════════════════ */
  const handleGalleryModalOpen = (clickType) => {
    setModalView(true);
    setImageType(clickType);
  };

  const handleGalleryModalClose = () => {
    setModalView(false);
  };

  /* ════════════════════════════════════
     File upload handler
  ════════════════════════════════════ */
  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    const api = `${Url}/api/v1/media/blogs/add`;

    if (file) {
      setImageSendPayload((prevData) => ({ ...prevData, file }));
      setUploadedStates("loading");
      const imagePayloadToSend = new FormData();
      imagePayloadToSend.append("image", file);
      imagePayloadToSend.append("alt_text", imageSendPayload.alt_text);
      imagePayloadToSend.append("title", imageSendPayload.title);
      imagePayloadToSend.append("description", imageSendPayload.description);
      imagePayloadToSend.append("link_url", imageSendPayload.link_url);
      await uploadImage(imagePayloadToSend, api, setUploadedStates);
    }
    setIsUploaded(true);
  };

  /* ════════════════════════════════════
     Image select from gallery — routes
     by imageType to the right state
  ════════════════════════════════════ */
  const handleImageSelect = (image) => {
    switch (imageType) {
      case "blog-image":
        setBlogImage(image);
        break;
      case "og-image":
        setMetaData((prev) => ({ ...prev, og_image: image.image_url }));
        setSelectedOgImage(image.image_url);
        break;
      case "x-image":
        setMetaData((prev) => ({ ...prev, x_image: image.image_url }));
        setSelectedXImage(image.image_url);
        break;
      case "editor-image": {
        const editorInstance = joditInstanceRef.current;
        const imageUrl = `${Url}${image.image_url}`;
        if (editorInstance) {
          editorInstance.selection.restore(selectionBookmarkRef.current);
          editorInstance.selection.insertHTML(
            `<img src="${imageUrl}" class="blog-content-image" alt="" />`
          );
          setFormData((prev) => ({
            ...prev,
            content: editorInstance.value,
          }));
        }
        joditInstanceRef.current = null;
        selectionBookmarkRef.current = null;
        break;
      }
      default:
        break;
    }
    setModalView(false);
  };

  const cancelBlogImage = () => setBlogImage(null);

  const cancelOgImage = () => {
    setSelectedOgImage(null);
    setMetaData((prev) => ({ ...prev, og_image: "" }));
  };

  const cancelXImage = () => {
    setSelectedXImage(null);
    setMetaData((prev) => ({ ...prev, x_image: "" }));
  };

  /* ════════════════════════════════════
     Reset form
  ════════════════════════════════════ */
  const resetForm = () => {
    setSelectedTags([]);
    setBlogImage(null);
    setIsEditID(null);
    setIsViewMode(false);
    setIsEditMode(false);
    setProductStatus("");
    setProductVisibility("");
    setPublishedStatus("");
    setCreatedStatus("");
    setPublishDate(null);
    setShowPublishDatePicker(false);
    setFormData({
      title: "",
      slug: "",
      author: "",
      content: "",
      selectedCategory: "",
      blogsTag: [],
      status: "draft",
    });
    setMetaData({
      metaTitle: "",
      metaDescription: "",
      metaKeywords: "",
      canonicalUrl: "",
      robots: "",
      ogTitle: "",
      ogDescription: "",
      og_image: "",
      xTitle: "",
      xDescription: "",
      x_image: "",
      schemaMarkup: "",
    });
    setSelectedOgImage(null);
    setSelectedXImage(null);
  };

  /* ════════════════════════════════════
     Fetch categories & tags
  ════════════════════════════════════ */
  const fetchBlogsCategories = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${Url}/api/v1/blog-categories/get`);
      const data = await response.json();

      if (!data || !data.categories) {
        console.error("No categories found in the response data");
        return;
      }

      const categories = data.categories.map((category) => ({
        _id: category._id,
        name: category.name,
      }));

      setBlogsCategories(categories);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchTags = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${Url}/api/v1/blog-tags/get`);
        const data = response.data.tags;
        setBlogsTag(data.map((tag) => ({ name: tag.name })));
      } catch (error) {
        console.error("Error fetching tags:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTags();
    fetchBlogsCategories();
  }, []);

  /* ════════════════════════════════════
     Mode detection from route
  ════════════════════════════════════ */
  useEffect(() => {
    const currentPath = location.pathname;
    const editMode = currentPath.includes("Edit");
    const viewMode = currentPath.includes("View");
    const data = editMode ? blog_Data : viewMode ? view_Data : null;

    if (data) {
      const status = capitalizeFirstLetter(data.status || "Select Product");
      const visibility = data.status === "draft" ? "Private" : "Public";
      const publishedDate =
        data.status === "draft"
          ? "Not Published Yet"
          : formatDate(data.publishedDate);

      const createdDate =
        data.status === "draft" || data.status === "pending"
          ? "Not Published Yet"
          : formatDate(data.createdAt);

      setProductStatus(status);
      setProductVisibility(visibility);
      setPublishedStatus(publishedDate);
      setCreatedStatus(createdDate);

      if (editMode) {
        handleEditOperation(data);
        setIsEditMode(true);
        setIsViewMode(false);
      } else {
        handleViewOperation(data);
        setIsViewMode(true);
        setIsEditMode(false);
      }
    } else {
      resetForm();
      setIsViewMode(false);
      setIsEditMode(false);
    }
  }, [blog_Data, view_Data, location.pathname]);

  /* ════════════════════════════════════
     Edit / View population
  ════════════════════════════════════ */
  const handleEditOperation = useCallback((data) => {
    try {
      setIsEdit(data);
      setIsEditID(data._id);

      const formattedTags = data.tags?.map((tag) => ({ name: tag })) || [];

      setFormData((prev) => ({
        ...prev,
        title: data.title || "",
        slug: data.slug || "",
        author: data.author || "",
        content: data.content || "",
        selectedCategory: data.category?._id || "",
        blogsTag: data.tags || [],
        status: data.status || "draft",
        publishedDate: data?.publishedDate
      }));

      setMetaData({
        metaTitle: data.meta?.title || "",
        metaDescription: data.meta?.description || "",
        metaKeywords: data.meta?.keywords || "",
        canonicalUrl: data.meta?.canonical_url || "",
        robots: data.meta?.robots || "",
        ogTitle: data.meta?.og_title || "",
        ogDescription: data.meta?.og_description || "",
        og_image: data.meta?.og_image || "",
        xTitle: data.meta?.x_title || "",
        xDescription: data.meta?.x_description || "",
        x_image: data.meta?.x_image || "",
        schemaMarkup: data.meta?.schemaMarkup
          ? JSON.stringify(data.meta.schemaMarkup, null, 2)
          : "",
      });

      setSelectedTags(formattedTags);
      setBlogImage(data.image);
      setSelectedOgImage(data.meta?.og_image || null);
      setSelectedXImage(data.meta?.x_image || null);
      setPublishDate(data.publishedDate ? new Date(data.publishedDate) : null);
    } catch (error) {
      console.error("Error in edit operation:", error);
    }
  }, []);

  const handleViewOperation = useCallback((data) => {
    try {
      setIsView(data);

      const formattedTags = data.tags?.map((tag) => ({ name: tag })) || [];

      setFormData((prev) => ({
        ...prev,
        title: data.title || "",
        slug: data.slug || "",
        author: data.author || "",
        content: data.content || "",
        selectedCategory: data.category?._id || "",
        blogsTag: data.tags || [],
        status: data.status || "draft",
        publishDate: data?.publishedDate
      }));

      setMetaData({
        metaTitle: data.meta?.title || "",
        metaDescription: data.meta?.description || "",
        metaKeywords: data.meta?.keywords || "",
        canonicalUrl: data.meta?.canonical_url || "",
        robots: data.meta?.robots || "",
        ogTitle: data.meta?.og_title || "",
        ogDescription: data.meta?.og_description || "",
        og_image: data.meta?.og_image || "",
        xTitle: data.meta?.x_title || "",
        xDescription: data.meta?.x_description || "",
        x_image: data.meta?.x_image || "",
        schemaMarkup: data.meta?.schemaMarkup
          ? JSON.stringify(data.meta.schemaMarkup, null, 2)
          : "",
      });

      setSelectedTags(formattedTags);
      setBlogImage(data.image);
      setSelectedOgImage(data.meta?.og_image || null);
      setPublishDate(data.publishedDate ? new Date(data.publishedDate) : null);
      setSelectedXImage(data.meta?.x_image || null);
    } catch (error) {
      console.error("Error in view operation:", error);
    }
  }, []);

  /* ════════════════════════════════════
     Input handlers
  ════════════════════════════════════ */
  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;

    setFormData((prevState) => {
      const updatedState = {
        ...prevState,
        [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
      };
      if (name === "title") {
        updatedState.slug = generateSlug(value);
      }
      return updatedState;
    });
  };

  const handleMetaChange = (e) => {
    const { name, value } = e.target;
    setMetaData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditorChange = (newContent) => {
    setFormData((prevState) => ({ ...prevState, content: newContent }));
  };

  /* ════════════════════════════════════
     Tag & category handlers
  ════════════════════════════════════ */
  const handleTagSelect = (tagName) => {
    setSelectedTags((prevTags) => {
      const isAlreadySelected = prevTags.some((tag) => tag.name === tagName);
      const updatedTags = isAlreadySelected
        ? prevTags.filter((tag) => tag.name !== tagName)
        : [...prevTags, { name: tagName }];

      setFormData((prevFormData) => ({
        ...prevFormData,
        blogsTag: updatedTags.map((tag) => tag.name),
      }));

      return updatedTags;
    });
  };

  const handleCategorySelect = (categoryId) => {
    setFormData((prevData) => {
      const isSelected = prevData.selectedCategory === categoryId;
      return {
        ...prevData,
        selectedCategory: isSelected ? "" : categoryId,
        selectedCategoryDetails: isSelected
          ? null
          : blogsCategories.find((cat) => cat._id === categoryId),
      };
    });
  };

  const handleDropdownStateChange = (isOpen, height) => {
    setIsDropdownOpen(isOpen);
    setDropdownHeight(height);
  };

  /* ════════════════════════════════════
     Accordion toggle
  ════════════════════════════════════ */
  const toggleAccordion = (index) => {
    setAccordionsOpen((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  /* ════════════════════════════════════
     SEO preview tab toggle
  ════════════════════════════════════ */
  const handleChange = (view) => {
    if (view === "Mobile") {
      setIsMobileAnimating(true);
      setTimeout(() => setIsMobileAnimating(false), 300);
    } else if (view === "Web") {
      setIsWebAnimating(true);
      setTimeout(() => setIsWebAnimating(false), 300);
    }
    setSelectedView(view);
  };

  /* ════════════════════════════════════
     Submit
  ════════════════════════════════════ */
  const handleBlogSubmit = async (status) => {
    setLoadingButton(status);
    setIsLoading(true);
    setSubmissionActive(true);

    let schemaObj = {};
    try {
      if (metaData.schemaMarkup) schemaObj = JSON.parse(metaData.schemaMarkup);
    } catch {
      schemaObj = {};
    }

    const blogPayload = {
      title: formData.title,
      slug: formData.slug,
      author: formData.author,
      content: formData.content,
      category: formData.selectedCategory,
      tags: formData.blogsTag,
      image: blogImage,
      status,
      publishedDate: publishDate ? publishDate.toISOString() : null,

      meta: {
        title: metaData.metaTitle,
        description: metaData.metaDescription,
        keywords: metaData.metaKeywords,
        canonical_url: metaData.canonicalUrl,
        robots: metaData.robots,
        og_title: metaData.ogTitle,
        og_description: metaData.ogDescription,
        og_image: metaData.og_image,
        x_title: metaData.xTitle,
        x_description: metaData.xDescription,
        x_image: metaData.x_image,
        schemaMarkup: schemaObj,
      },
    };

    const token = sessionStorage.getItem("authToken");
    const headers = {
      Authorization: `Bearer ${token}`,
      "x-api-key": security_key,
    };

    try {
      let message = isEditMode
        ? "Blog updated successfully!"
        : "Blog submitted successfully!";

      if (isEditMode) {
        await axios.put(
          `${Url}/api/v1/blogs/edit/${isEditID}`,
          blogPayload,
          { headers }
        );
      } else {
        await axios.post(`${Url}/api/v1/blogs/add`, blogPayload, { headers });
      }

      setToastMessage(message);
      setShowMessage(true);
      resetForm();

      setTimeout(() => {
        navigate("/Blogs/All-Blogs");
      }, 2000);
    } catch (error) {
      console.error(
        `Error ${isEditMode ? "updating" : "submitting"} blog:`,
        error
      );
      setToastMessage("Failed to save or update Blog. Please try again.");
      setShowMessage(true);
    } finally {
      setIsLoading(false);
      setSubmissionActive(false);
      setLoadingButton(null);
    }
  };

  /* ════════════════════════════════════
     Navigation helpers
  ════════════════════════════════════ */
  const handleEditNavigation = () => {
    navigate(`/Blogs/Edit-Blog/${view_Data._id}`, {
      state: { blog_Data: view_Data },
    });
  };


  const handleRenderedView = (row) => {
    const previewId = isEditID || "preview";
    navigate(`/Blogs/Quick-View/${previewId}`, { state: row });
  };
  const handleCancel = () => {
    resetForm();
    setIsEditMode(false);
    setIsViewMode(false);
    navigate("/Blogs/All-Blogs");
  };

  const handleArchive = () => {
    console.log("Handle Archive button has been clicked.");
  };

  /* ════════════════════════════════════
     Right-side accordion items
  ════════════════════════════════════ */
  const accordionItems = [
    {
      title: "Status",
      content: (
        <div className="Blogs-PublishContainer">
          <div className="Blogs-StartContainer">
            <div>
              {isEditMode && (
                <CustomBtn
                  label={
                    loadingButton === "published" ? (
                      <div className="btn-loader-Publish"></div>
                    ) : isEditMode ? (
                      "Save Draft"
                    ) : (
                      "Published"
                    )
                  }
                  withIcon={false}
                  disabled={loadingButton === "published"}
                  className={`${isEditMode ? "DraftBtn" : "Blogs-PublishBtn"} ${loadingButton === "draft" ? "active" : ""
                    }`}
                  onClick={() =>
                    handleBlogSubmit(isEditMode ? "draft" : "published")
                  }
                  type="button"
                />
              )}
            </div>
          </div>

          <div className="Blogs-MidContainer">
            <div className="MidRowsData">
              <div className="RowContent">
                <img src={imageStatus} alt="Status" className="ImageStyle" />
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start" }}>
                  <span className="TextStyle1 blogs">Status:</span>

                  <span className="TextStyle2">
                    {isEditMode || isViewMode ? productStatus : "Pending"}
                  </span>
                </div>
              </div>
              {isViewMode ? <div onClick={() => {
                if (formData.title != "" && formData.content != "") {
                  handleRenderedView({ ...formData, image: blogImage })
                } else {
                  if (formData.title === "") {
                    setToastMessage("Please Add the Title");
                    setShowMessage(true);
                  } else {
                    setToastMessage("Please Add Some Content");
                    setShowMessage(true);
                  }

                }

              }}>
                <BsEye className="NoteIcon" />
              </div> : <div>
                {/* <PiNotePencil className="NoteIcon" /> */}
              </div>}
            </div>

            <div className="MidRowsData">
              <div className="RowContent">
                <img
                  src={imagePublish}
                  alt="Publish"
                  className="ImageStyle"
                />
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start" }}>
                  <span className="TextStyle1 blogs">Created Date:</span>
                  <span className="TextStyle2">
                    {isEditMode || isViewMode
                      ? productCreatedStatus
                      : "12/31/2024"}
                  </span>
                </div>
              </div>
              <div>
                {/* <PiNotePencil className="NoteIcon" /> */}
              </div>
            </div>
            <div className="MidRowsData">
              <div className="RowContent">
                <img src={imagePublish} alt="Publish" className="ImageStyle" />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                  }}
                >
                  <span className="TextStyle1 blogs">Publish Date:</span>
                  <span className="TextStyle2">
                    {publishDate
                      ? publishDate.toLocaleDateString()
                      : isEditMode || isViewMode
                        ? productPublishedStatus
                        : "Not Set"}
                  </span>
                </div>
              </div>

              <div style={{ position: "relative" }}>
                {!isViewMode && (
                  <PiNotePencil
                    className="NoteIcon"
                    onClick={() => setShowPublishDatePicker((prev) => !prev)}
                  />
                )}

                <DatePicker
                  selected={publishDate}
                  onChange={(date) => {
                    setPublishDate(date);
                    setShowPublishDatePicker(false);
                  }}
                  open={showPublishDatePicker}
                  onClickOutside={() => setShowPublishDatePicker(false)}
                  customInput={<input style={{ display: "none" }} readOnly />}
                  popperPlacement="bottom-end"
                />
              </div>
            </div>
          </div>

          <div className="Blogs-EndContainer">
            <div>
              {isViewMode ? (
                <div>
                  <CustomBtn
                    label="Edit Blog"
                    withIcon={false}
                    disabled={false}
                    className="Blogs-PublishBtn"
                    onClick={() => handleEditNavigation()}
                    type="button"
                  />
                </div>
              ) : (
                <div>
                  <CustomBtn
                    label={
                      loadingButton === "draft" ? (
                        <div className="btn-loader-Draft"></div>
                      ) : isEditMode ? (
                        "Published"
                      ) : (
                        "Save Draft"
                      )
                    }
                    withIcon={false}
                    disabled={loadingButton === "draft"}
                    className={`${isEditMode ? "Blogs-PublishBtn" : "DraftBtn"
                      } ${loadingButton === "published" ? "active1" : ""}`}
                    onClick={() =>
                      handleBlogSubmit(isEditMode ? "published" : "draft")
                    }
                    type="button"
                  />
                </div>
              )}
            </div>

            <div>
              {!isEditMode && !isViewMode ? (
                <CustomBtn
                  label="Publish"
                  withIcon={false}
                  disabled={false}
                  className="Blogs-PublishBtn"
                  onClick={() => handleBlogSubmit("published")}
                  type="button"
                />
              ) : (
                <CustomBtn
                  label={isViewMode ? "Cancel" : "Cancel"}
                  withIcon={false}
                  disabled={false}
                  className={isViewMode ? "DraftBtn" : "DraftBtn"}
                  onClick={handleCancel}
                  type="button"
                />
              )}
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "Blog Image",
      content: (
        <div className="banner-upload">
          {blogImage ? (
            <div className="image-preview-wrapper">
              <img
                src={`${Url + blogImage.image_url}`}
                alt="Thumbnail"
                className="dimensional-image-preview"
              />
              {!isViewMode && (
                <button onClick={cancelBlogImage} className="cancel-button">
                  X
                </button>
              )}
            </div>
          ) : (
            <label
              htmlFor="blogImage"
              className="uploadAdd-label"
              onClick={() => handleGalleryModalOpen("blog-image")}
            >
              <div className="Addupload-button">
                <IoImageOutline
                  size={45}
                  color="#555"
                  className="uploaded-image"
                />
                <span className="uploadAdd-text">Click to Upload Image</span>
              </div>
            </label>
          )}
          <ImageGalleryPopup
            showImageGalleryPopUp={modalView && (imageType === "blog-image" || imageType === "editor-image")}
            handleModalView={handleGalleryModalClose}
            handleFileChange={handleFileChange}
            onImageSelect={handleImageSelect}
            imageSendPayload={imageSendPayload}
            setImageSendPayload={setImageSendPayload}
            alt_text={imageSendPayload.alt_text}
            title={imageSendPayload.title}
            data={modaldata}
            getData={getApi}
          />
        </div>
      ),
    },
    {
      title: "Select Categories",
      content: (
        <div className="category-list">
          {blogsCategories &&
            blogsCategories.map((category) => (
              <div
                key={category._id}
                className="main-category"
                style={{ marginBottom: "10px" }}
              >
                <div className="category-item-heading">
                  <label
                    className={`checkbox-wrapper ${isViewMode && formData.selectedCategory === category._id
                      ? "viewmode-checked"
                      : ""
                      }`}
                  >
                    <input
                      type="checkbox"
                      disabled={isViewMode}
                      checked={formData.selectedCategory === category._id}
                      onChange={() => handleCategorySelect(category._id)}
                    />
                    <span className="custom-checkbox"></span>
                    <span>{category.name}</span>
                  </label>
                </div>
              </div>
            ))}
        </div>
      ),
    },
    {
      title: "Select Tags",
      content: (
        <div
          style={{
            fontFamily: "var(--font-family)",
            fontSize: "var(--font-size-small)",
            height: isDropdownOpen ? `${dropdownHeight + 50}px` : "auto",
            transition: "height 0.3s ease",
            overflow: "auto",
          }}
        >
          <div className="GeneralFields-Data">
            <div className="GeneralFields-Data-Tag">
              <SearchMultiple
                name="multiSelect"
                placeholder="Search & Select Tags..."
                options={blogsTag.map((tag) => tag.name)}
                onSelect={(option) => handleTagSelect(option)}
                selectedItems={selectedTags.map((tag) => tag.name)}
                width="100%"
                suggestionListWidth="100%"
                onDropdownStateChange={handleDropdownStateChange}
                isViewMode={isViewMode}
              />
            </div>
          </div>
        </div>
      ),
    },
  ];

  /* ════════════════════════════════════
     SEO accordion section titles
  ════════════════════════════════════ */
  const seoAccordionTitles = [
    "Search Appearance",
    "Open Graph (OG)",
    "X (Twitter) Card",
    "Schema Markup",
  ];


  // const editorConfig = useMemo(
  //   () => ({
  //     ...imageConfigEditor,
  //     readonly: isViewMode,
  //   }),
  //   [isViewMode]
  // );

  // add near your other refs
  const joditInstanceRef = useRef(null);
  const selectionBookmarkRef = useRef(null);

  const editorConfig = useMemo(
    () => ({
      ...imageConfigEditor,
      readonly: isViewMode,
      controls: {
        ...(imageConfigEditor.controls || {}),
        image: {
          ...(imageConfigEditor.controls?.image || {}),
          // 👇 this replaces Jodit's built-in Upload/URL popup entirely
          exec: (editorInstance) => {
            joditInstanceRef.current = editorInstance;
            selectionBookmarkRef.current = editorInstance.selection.save();
            handleGalleryModalOpen("editor-image");
          },
        },
      },
    }),
    [isViewMode]
  );


  /* ════════════════════════════════════
     Render
  ════════════════════════════════════ */
  return (
    <div className="AddProductPage">
      {loading && (
        <div className="backdrop">
          <div className="loader-container">
            <MainLoader />
          </div>
        </div>
      )}

      {/* ══════════════════════════════
          LEFT SIDE
      ══════════════════════════════ */}
      <div className="PageLeftSide blogs">

        {/* ── Main content fields ── */}
        <div className="BlogsDescription">
          <div className="Blog-Container1-Row-1">
            <div style={{ width: "75%" }}>
              <label htmlFor="title" className="DescriptionLabels">
                Title
              </label>
              <textarea
                id="title"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                className="Blog-Title-Input"
                placeholder="Cypress Bedroom Set in Gray"
                disabled={isViewMode}
              />
            </div>
            <div style={{ width: "25%" }}>
              <label htmlFor="author" className="DescriptionLabels">
                Author
              </label>
              <textarea
                id="author"
                name="author"
                value={formData.author}
                onChange={handleInputChange}
                className="Blog-Title-Input"
                placeholder="John Doe"
                disabled={isViewMode}
              />
            </div>
          </div>

          {/* ── Rich Text Editor ── */}
          <div className="Blog-Container1-Row-2">
            <label htmlFor="editor" className="BlogContent-Heading">
              Blog Description
            </label>
            <div className="Blogs-Editor-Container">
              <div className="Blogs-Editor-Tabs">
                <div
                  className={`Tab ${selectedTab === "Visual" ? "active" : ""}`}
                  onClick={() => setSelectedTab("Visual")}
                >
                  Visual
                </div>
                <div
                  className={`Tab ${selectedTab === "Text" ? "active" : ""}`}
                  onClick={() => setSelectedTab("Text")}
                >
                  Text
                </div>
              </div>
              <div className="Editor-Content-Blog">
                {selectedTab === "Visual" ? (
                  <JoditEditor

                    ref={editor}
                    value={formData.content}
                    tabIndex={1}
                    onBlur={handleEditorChange}
                    config={editorConfig}
                  />
                ) : (
                  <textarea
                    id="content"
                    name="content"
                    value={formData.content}
                    readOnly={isViewMode}
                    onChange={handleInputChange}
                    className="Blog-Editor-Text-Area"
                    placeholder="Blog Content"
                  />
                )}
              </div>
            </div>
          </div>
        </div>

      </div>

      {/* ══════════════════════════════
          RIGHT SIDE — accordions
      ══════════════════════════════ */}
      <div className="PageRightSide blogs">
        {accordionItems.map((item, index) => (
          <AccordionItem
            overflowS={true}
            key={index}
            title={item.title}
            content={item.content}
            defaultOpen={index === 0}
            maxHeight="2000px"
          />
        ))}
      </div>

      <BottomToust
        showMessage={showMessage}
        message={toastMessage}
        handleCloseMessageModal={() => setShowMessage(false)}
      />
    </div>
  );
};

export default AddBlogs;
